import { useGateValue } from "@statsig/react-bindings";

export const useEnableBillingUsageExport = (): boolean => {
  return useGateValue("enable_billing_usage_export");
};
